import { useCallback, useState } from "react";
import {
  DEFAULT_LIST_PAGE_SIZE,
  readStoredListPageSize,
  writeStoredListPageSize,
} from "../Utility/Pagination/listPaginationConstants";

/**
 * Persisted page size for list tables (clients, projects).
 * @param {string} storageKey
 * @param {number} [initialFallback]
 */
export function useListPageSize(storageKey, initialFallback = DEFAULT_LIST_PAGE_SIZE) {
  const [pageSize, setPageSizeState] = useState(() => {
    if (storageKey) return readStoredListPageSize(storageKey);
    return initialFallback;
  });

  const setPageSize = useCallback(
    (next) => {
      const n = Number(next);
      setPageSizeState(n);
      if (storageKey) writeStoredListPageSize(storageKey, n);
    },
    [storageKey]
  );

  return { pageSize, setPageSize };
}
